import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import  MyEmployeeService  from "../../../../services/HR/myemployee.service";
import { makeStyles } from "@mui/styles";

export default function MemberTransactionLog() {
  const classes = useStyles();
  const selector = useSelector(state => state);
  const [data, setData] = React.useState({
    total_records: 0,
    current_page: 0,
    items: []
  });
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10
  });
  const [loading, setLoading] = React.useState(false);
  const columns = [
    { field: "updated_by", headerName: "Updated By", minWidth: 300 },
    { field: "policy_no", headerName: "Reference/Policy No.", minWidth: 300 },
    { field: "person_name", headerName: "Member/Dependent", minWidth: 300 },
    { field: "request_type", headerName: "Request Type", minWidth: 300 },
    { field: "created_date", headerName: "Date and Time", minWidth: 300 },
  ];

  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      const policyNo = selector.HR.coverage.policy?.policy_no;

      if (!policyNo) {
        setLoading(false);
        return;
      }

      const result = await MyEmployeeService.getMemberTransactionLog(
        policyNo,
        paginationModel.page,
        paginationModel.pageSize
      );
      console.log("result", result);

      setData(result.data);
      setLoading(false);
    };

    fetchData();
  }, [paginationModel]);
  return (
    <div className={classes.dataGridContainer}>
      <DataGrid
        rows={data.items}
        columns={columns}
        getRowId={row => row.id}
        pagination
        paginationMode="server"
        rowCount={data.total_records}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        pageSizeOptions={[5, 10]}
        loading={loading}
      />
    </div>
  );
}

const useStyles = makeStyles({
  dataGridContainer: { height: 600, width: "100%" },
  downloadLink: { cursor: "pointer", display: "flex", alignItems: "center", height: "100%" },
  downloadIcon: { color: "#b3b3b3", marginLeft: "80px" }
});
